module.exports = __webpack_public_path__ + "static/media/user-silhouette.2aa71531.svg";